import type { EmailCampaignPubblico } from '../../types/email.types';

/**
 * A chi va una campagna: le regole che la pagina mostra.
 *
 * Le stesse regole le fa rispettare il database (migrazione 24), che e' quello
 * che conta davvero. Qui servono a dirlo prima, con parole chiare, invece di
 * lasciare che sia il database a rispondere di no al momento dell'invio.
 */

export interface SceltaPubblico {
  pubblico: EmailCampaignPubblico;
  /** Le liste scelte, in ordine di scelta. Contano solo se pubblico = 'liste'. */
  liste: string[];
}

/** Cosa manca perche' la scelta sia completa, oppure null se e' a posto. */
export function problemaPubblico(scelta: SceltaPubblico): string | null {
  if (scelta.pubblico === 'da_scegliere') return 'Scegli a chi mandarla';
  if (scelta.pubblico === 'liste' && scelta.liste.length === 0) return 'Scegli almeno una lista';
  return null;
}

/** La scelta detta a parole, per i riepiloghi e per la conferma di invio. */
export function descriviPubblico(scelta: SceltaPubblico, nomi: Record<string, string>): string {
  if (scelta.pubblico === 'da_scegliere') return 'Destinatari non ancora scelti';
  if (scelta.pubblico === 'tutti') return 'Tutti i contatti che possono ricevere';

  const elenco = scelta.liste.map((id) => `"${nomi[id] ?? 'lista eliminata'}"`);
  return elenco.length === 1 ? `La lista ${elenco[0]}` : `Le liste ${elenco.join(', ')}`;
}

/** Mette o toglie una lista dalla scelta, senza toccare l'elenco di partenza. */
export function alternaLista(liste: readonly string[], id: string): string[] {
  return liste.includes(id) ? liste.filter((l) => l !== id) : [...liste, id];
}

/**
 * Divide un elenco lungo in pezzi. Serve quando si mettono in una lista
 * centinaia di contatti insieme: una richiesta sola troppo grande il database
 * la rifiuta.
 */
export function aBlocchi<T>(elenco: readonly T[], misura: number): T[][] {
  const pezzi: T[][] = [];
  for (let i = 0; i < elenco.length; i += misura) {
    pezzi.push(elenco.slice(i, i + misura));
  }
  return pezzi;
}
